import React from 'react'
import Trackreturn from '../Components/OrderDetails/Trackreturn';
import Relatedproducts from '../Components/Productdetails/Relatedproducts';
import Breadcrumb from '../Components/Breadcrumb';
import { useEffect } from 'react';
function Trackreturnpage() {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <>
    <Breadcrumb title_1 = "Your Account" title_2 = "Orders" title_3 = "Track Return" />
      <Trackreturn />
      <Relatedproducts/>
    </>
  )
}

export default Trackreturnpage
